// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ylpp","content":"styles_content__1xOgG","row":"styles_row__B87dS","footer":"styles_footer__3Gu9P","phraseLength":"styles_phraseLength__1pi8E"};